/**
 * Returns the Popup class.
 *
 * Unfortunately, the Popup class can only be defined after
 * google.maps.OverlayView is defined, when the Maps API is loaded.
 * This function should be called by initMap.
 */
export function createPopupClass() {
  const Popup = class extends window.google.maps.OverlayView {
    position: any;
    containerDiv: any;
    isClosed = false;

    constructor(position: any, content: any) {
      super();
      // Initialize all properties.
      this.position = position;
      content.classList.add('popup-bubble');

      // This zero-height div is positioned at the bottom of the bubble.
      const bubbleAnchor = document.createElement('div');
      bubbleAnchor.classList.add('popup-bubble-anchor');
      bubbleAnchor.appendChild(content);

      // This zero-height div is positioned at the bottom of the tip.
      this.containerDiv = document.createElement('div');
      this.containerDiv.classList.add('popup-container');
      this.containerDiv.appendChild(bubbleAnchor);

      const closeButtons = bubbleAnchor.querySelectorAll('.popup-close');
      for (const button of closeButtons) {
        button.addEventListener('click', () => {
          //this.setMap(null); => caused leak
          if (this.containerDiv) this.containerDiv.style.display = 'none';
          this.isClosed = true;
        });
      }
      // Optionally stop clicks, etc., from bubbling up to the map.
      google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.containerDiv);
    }

    /**
     * onAdd is called when the map's panes are ready and the overlay has been
     * added to the map.
     */
    onAdd() {
      if (this.containerDiv) this.getPanes().floatPane.appendChild(this.containerDiv);
    }

    draw() {
      if (!this.containerDiv || this.isClosed) return;

      const divPosition = this.getProjection().fromLatLngToDivPixel(this.position);

      // Hide the popup when it is far out of view.
      const display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ? 'block' : 'none';

      if (display === 'block') {
        this.containerDiv.style.left = divPosition.x + 'px';
        this.containerDiv.style.top = divPosition.y + 'px';
      }
      if (this.containerDiv.style.display !== display) {
        this.containerDiv.style.display = display;
      }
    }

    // The onRemove() method will be called automatically from the API if
    // we ever set the overlay's map property to 'null'.
    onRemove() {
      if (this.containerDiv.parentElement) {
        this.containerDiv.parentElement.removeChild(this.containerDiv);
      }
      if (this.containerDiv) {
        this.containerDiv = null;
      }
    }
  };
  return Popup;
}
